module.exports = __webpack_public_path__ + "img/stamp-fruit-roots-pear.f1eb5b21.png";